import periods from "@Resources/js/modules/analytics/Helpers/TimePeriods";
import { defaultPeriod } from "@Resources/js/modules/analytics/Helpers/TimePeriods";

export default {
    state: {
        period: defaultPeriod,
        label: periods[defaultPeriod].label,
        start: periods[defaultPeriod].start(),
        end: periods[defaultPeriod].end(),

        statsUsers: [],
        statsDomains: [],
        statsUrls: [],
        statsTags: [],
    },

    getters: {
        statsUsers: (state) => state.statsUsers,
        statsDomains: (state) => state.statsDomains,
        statsUrls: (state) => state.statsUrls,
        statsTags: (state) => state.statsTags,

        statsDatetime: (state) => {
            return {
                value: state.period,
                label: state.label,
                start: state.start,
                end: state.end,
            };
        },
    },

    mutations: {
        REFRESH_STATS_DATETIME(state) {
            const currentPeriod = periods[state.period];

            if (currentPeriod) {
                state.start = currentPeriod.start();
                state.end = currentPeriod.end();
            }
        },

        RESET_STATS_DATETIME(state) {
            state.period = defaultPeriod;
            state.label = periods[defaultPeriod].label;
            state.start = periods[defaultPeriod].start();
            state.end = periods[defaultPeriod].end();
        },

        SET_STATS_DATETIME(state, datetime) {
            state.end = datetime.end;
            state.start = datetime.start;
            state.label = datetime.label;
            state.period = datetime.value;
        },

        statsUsers(state, users) {
            state.statsUsers = users;
        },

        statsDomains(state, domains) {
            state.statsDomains = domains;
        },

        statsUrls(state, urls) {
            state.statsUrls = urls.flat();
        },

        statsTags(state, tags) {
            state.statsTags = tags.flat();
        },
    },
};
